import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let ResetButton = class ResetButton extends Vue {
  resetConfiguration() {
    this.$store.commit("resetConfiguration", {
      forma: this.defaultFrontModel,
      colore: this.defaultFrontColor,
      coloreAste: this.defaultTemplesColor
    });
    this.$store.commit("setLenteDx", null);
    this.$store.commit("setLenteSx", null);
    this.$store.commit("resetLentiVista");
    this.$store.commit("configurator/lenti/resetCfgLenteVistaDx");
    this.$store.commit("configurator/lenti/resetCfgLenteVistaSx");
  }
};
__decorate([Prop({
  default: ""
})], ResetButton.prototype, "defaultFrontModel", void 0);
__decorate([Prop({
  default: ""
})], ResetButton.prototype, "defaultFrontColor", void 0);
__decorate([Prop({
  default: ""
})], ResetButton.prototype, "defaultTemplesColor", void 0);
ResetButton = __decorate([Component({})], ResetButton);
export default ResetButton;